import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { DASHBOARD } from '@config/modelsConfig';
import { DashboardFiltersWrapper } from '@layout/DashboardFilters';
import { DatePicker, Button } from '@atoms';
import { TextInput } from '@molecules';
import messages from './messages';

class DashboardFilters extends PureComponent {
  static propTypes = {
    [DASHBOARD.FILTER.FROM_DATE]: PropTypes.instanceOf(Date),
    [DASHBOARD.FILTER.TO_DATE]: PropTypes.instanceOf(Date),
    [DASHBOARD.FILTER.TITLE]: PropTypes.string,
    [DASHBOARD.FILTER.ANALYST]: PropTypes.string,
    setFilterField: PropTypes.func.isRequired,
    applyFilter: PropTypes.func.isRequired,
    target: PropTypes.string,
    isFetching: PropTypes.bool,
  };

  static defaultProps = {
    [DASHBOARD.FILTER.TITLE]: '',
    [DASHBOARD.FILTER.ANALYST]: '',
    target: undefined,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.applyFilter();
  };

  formatDate = (date) => (date ? new Date(date) : undefined);

  setDateFilter = (fieldName) => (value) =>
    this.props.setFilterField(fieldName, new Date(value));

  setTitle = ({ target: { value } }) =>
    this.props.setFilterField(DASHBOARD.FILTER.TITLE, value);

  setAnalyst = ({ target: { value } }) =>
    this.props.setFilterField(DASHBOARD.FILTER.ANALYST, value);

  render() {
    const { isFetching, target } = this.props;
    return (
      <form onSubmit={this.handleSubmit}>
        <DashboardFiltersWrapper>
          <TextInput
            id="conferences-title-filter"
            value={this.props[DASHBOARD.FILTER.TITLE]}
            onChange={this.setTitle}
            icon="magnifyingGlass"
          />
          {target !== 'attendee' && (
            <TextInput
              id="analyst-filed"
              value={this.props[DASHBOARD.FILTER.ANALYST]}
              onChange={this.setAnalyst}
              label={<FormattedMessage {...messages[DASHBOARD.FILTER.ANALYST]} />}
              inline
              gap="5px"
            />
          )}
          <DatePicker
            id="conferences-from"
            placeholder={<FormattedMessage {...messages[DASHBOARD.FILTER.FROM_DATE]} />}
            onChange={this.setDateFilter(DASHBOARD.FILTER.FROM_DATE)}
            value={this.formatDate(this.props[DASHBOARD.FILTER.FROM_DATE])}
          />
          <DatePicker
            id="conferences-to"
            placeholder={<FormattedMessage {...messages[DASHBOARD.FILTER.TO_DATE]} />}
            onChange={this.setDateFilter(DASHBOARD.FILTER.TO_DATE)}
            value={this.formatDate(this.props[DASHBOARD.FILTER.TO_DATE])}
          />
          <Button small disabled={isFetching}>
            <FormattedMessage {...messages.filter} />
          </Button>
        </DashboardFiltersWrapper>
      </form>
    );
  }
}

export default DashboardFilters;



// WEBPACK FOOTER //
// ./components/molecules/DashboardFilters/DashboardFilters.js